"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.providerTypeToComponentMap = exports.MapFactory = void 0;
var _react = require("react");
var _models = require("../../models");
var _Loading = require("../Loading");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const providerTypeToComponentMap = exports.providerTypeToComponentMap = new Map([
// [MapProviderType.Azure, lazy(async () => import('./AzureMap'))],
[_models.MapProviderType.Google, /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('./GoogleMap'))))], [_models.MapProviderType.Yandex, /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('./YandexMap'))))], [_models.MapProviderType.Bing, /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('./BingMap'))))]]);
const MapFactory = props => {
  const {
    isMapVisible,
    provider
  } = props;
  const MapComponent = providerTypeToComponentMap.get(provider);
  if (!MapComponent) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: isMapVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.DialogLoadingOverlay, {
      id: _models.TestId.DialogLoadingOverlayMapFactory
    }) : undefined,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(MapComponent, {
      ...props
    })
  });
};
exports.MapFactory = MapFactory;